import React, { useState } from 'react';
import { LegalModal } from '../ui/LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <footer className="bg-black py-12 border-t border-white/10" data-id="element-29">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-30">
        <h3 className="text-2xl font-heading font-bold text-white/80 mb-6 tracking-widest" data-id="element-31">
          PARRILLADA SIN DOLOR
        </h3>
        <p className="text-offwhite/40 text-sm max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-32">
          Descargo de responsabilidad: La información contenida en esta guía es
          para fines educativos y no sustituye el consejo médico profesional.
          Consulte a su médico antes de realizar cambios significativos en su
          dieta, especialmente si padece condiciones médicas preexistentes.
        </p>

        <div className="flex items-center justify-center gap-6 mb-6" data-id="element-33">
          <button onClick={() => setPrivacyOpen(true)} className="text-offwhite/50 hover:text-amber text-sm font-medium transition-colors underline underline-offset-4 decoration-offwhite/20 hover:decoration-amber" data-id="element-34">
            Política de Privacidad
          </button>
          <span className="text-offwhite/20" data-id="element-35">|</span>
          <button onClick={() => setTermsOpen(true)} className="text-offwhite/50 hover:text-amber text-sm font-medium transition-colors underline underline-offset-4 decoration-offwhite/20 hover:decoration-amber" data-id="element-36">
            Términos y Condiciones
          </button>
        </div>

        <div className="text-offwhite/30 text-sm" data-id="element-37">
          &copy; {new Date().getFullYear()} Parrillada Sin Dolor. Todos los
          derechos reservados.
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-38">
        <p data-id="element-39">
          <strong className="text-white" data-id="element-40">Última actualización:</strong> Marzo
          2026
        </p>

        <p data-id="element-41">
          En Parrillada Sin Dolor, respetamos tu privacidad y nos comprometemos
          a proteger la información personal que compartas con nosotros. Esta
          política describe cómo recopilamos, usamos y protegemos tus datos.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-42">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-43">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital, incluyendo: nombre, dirección
          de correo electrónico e información de pago. No almacenamos datos de
          tarjetas de crédito directamente; estos son procesados por nuestro
          proveedor de pagos seguro.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-44">
          2. Uso de la Información
        </h3>
        <p data-id="element-45">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-46">
          <li data-id="element-47">Procesar y entregar tu compra digital.</li>
          <li data-id="element-48">
            Enviarte el enlace de descarga y actualizaciones del producto.
          </li>
          <li data-id="element-49">Responder a consultas de soporte relacionadas con tu compra.</li>
        </ul>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-50">
          3. Protección de Datos
        </h3>
        <p data-id="element-51">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-52">
          4. Compartición con Terceros
        </h3>
        <p data-id="element-53">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación de nuestro sitio web y el procesamiento de
          pagos.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-54">5. Cookies</h3>
        <p data-id="element-55">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes desactivar las
          cookies en la configuración de tu navegador.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-56">6. Tus Derechos</h3>
        <p data-id="element-57">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos,
          contáctanos a través de los canales disponibles en nuestro sitio.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-58">
        <p data-id="element-59">
          <strong className="text-white" data-id="element-60">Última actualización:</strong> Marzo
          2026
        </p>

        <p data-id="element-61">
          Al adquirir y utilizar la guía "Parrillada Sin Dolor", aceptas los
          siguientes términos y condiciones. Por favor, léelos cuidadosamente
          antes de realizar tu compra.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-62">
          1. Producto Digital
        </h3>
        <p data-id="element-63">
          "Parrillada Sin Dolor" es un producto digital (PDF) que se entrega
          electrónicamente tras la confirmación del pago. Recibirás acceso
          instantáneo al contenido después de completar la transacción.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-64">2. Uso Personal</h3>
        <p data-id="element-65">
          La guía es para uso personal únicamente. Queda prohibida la
          reproducción, distribución, reventa o compartición del contenido sin
          autorización expresa por escrito.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-66">
          3. Descargo de Responsabilidad Médica
        </h3>
        <p data-id="element-67">
          La información proporcionada en esta guía es de carácter educativo e
          informativo. No constituye consejo médico, diagnóstico ni tratamiento.
          Siempre consulta con un profesional de la salud calificado antes de
          realizar cambios en tu dieta o estilo de vida, especialmente si
          padeces condiciones médicas preexistentes como gota, artritis u otras
          enfermedades inflamatorias.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-68">4. Resultados</h3>
        <p data-id="element-69">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que estos dependen de múltiples factores
          individuales incluyendo estado de salud, adherencia a las
          recomendaciones y otros hábitos de vida.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-70">
          5. Política de Reembolso
        </h3>
        <p data-id="element-71">
          Debido a la naturaleza digital del producto y el acceso instantáneo al
          contenido, todas las ventas son finales. Si experimentas problemas
          técnicos para acceder al producto, contáctanos y resolveremos el
          problema.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-72">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-73">
          Todo el contenido de "Parrillada Sin Dolor", incluyendo textos,
          recetas, gráficos y diseño, está protegido por derechos de autor.
          Cualquier uso no autorizado será perseguido conforme a la ley
          aplicable.
        </p>

        <h3 className="text-white font-bold text-base mt-6" data-id="element-74">
          7. Modificaciones
        </h3>
        <p data-id="element-75">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          este sitio.
        </p>
      </LegalModal>
    </footer>;
}